function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { $app } from './play-candidato-mod';
export var CandidatoConfig = /*#__PURE__*/_createClass(function CandidatoConfig() {
  _classCallCheck(this, CandidatoConfig);
  _defineProperty(this, "debugtoggle", true);
  _defineProperty(this, "debugforce", false);
  _defineProperty(this, "debug", false);
});
$app.service('CandidatoCfg', CandidatoConfig);
$app.config(["$stateProvider", "$urlRouterProvider", "$urlServiceProvider", "$locationProvider", "$compileProvider", "vcRecaptchaServiceProvider", function ($stateProvider, $urlRouterProvider, $urlServiceProvider, $locationProvider, $compileProvider, vcRecaptchaServiceProvider) {
  vcRecaptchaServiceProvider.setSiteKey(__RECAPTCHASITEKEY__);
  // vcRecaptchaServiceProvider.setTheme('---- light or dark ----')
  // vcRecaptchaServiceProvider.setStoken('--- YOUR GENERATED SECURE TOKEN ---')
  // vcRecaptchaServiceProvider.setSize('---- compact, normal or invisible ----')
  // vcRecaptchaServiceProvider.setType('---- audio or image ----')
  // vcRecaptchaServiceProvider.setLang('---- language code ----')

  if (false) {
    $compileProvider.debugInfoEnabled(false);
    $compileProvider.commentDirectivesEnabled(false);
    $compileProvider.cssClassDirectivesEnabled(false);
  }

  // esto es para ngupgrade
  // $urlServiceProvider.deferIntercept()

  $locationProvider.html5Mode(false);
  $urlRouterProvider.otherwise('/c/s');
  $stateProvider.state('root', {
    url: '/',
    component: 'playApp',
    onEnter: function onEnter() {
      console.log('enter playApp');
    }
  });
  $stateProvider.state('app', {
    url: '/app',
    component: 'playApp',
    onEnter: function onEnter() {
      console.log('enter playApp app');
    }
  });
  $stateProvider.state('app.menu', {
    url: '/menu',
    component: 'panelMenu',
    onEnter: function onEnter() {
      console.log('enter panelMenu');
    }
  });
  $stateProvider.state('app.formular', {
    url: '/form',
    component: 'panelFormular',
    onEnter: function onEnter() {
      console.log('enter panelFormular');
    }
  });
  $stateProvider.state('app.preguntas', {
    url: '/q',
    component: 'panelPreguntas',
    onEnter: function onEnter() {
      console.log('enter panelPreguntas');
    }
  });
  $stateProvider.state('view', {
    url: '/view',
    template: '<ui-view></ui-view>',
    resolve: {
      // user: ($log: angular.ILogService, $stateParams: ng.ui.IStateParamsService, $state: ng.ui.IStateService, AccesoDatos: AccesoDatos) => {
      //     return AccesoDatos.Login_CLIENT.userDetails().then(login => login, error => {
      //         //
      //         $log.info("sin login")
      //         $state.go("priv.login")
      //     })
      // }
    },
    onEnter: ["$state", function onEnter($state) {
      console.log('enter view');

      // $state.go("priv.login")
    }]
    // redirectTo: () => "priv.login"
  });
  $stateProvider.state('view.cv', {
    url: '/cvv/{i}',
    component: 'panelCvView',
    // template: `<panel-cv cv="$resolve.cv"> </panel-cv>`,
    resolve: {
      cv: ["$stateParams", "AccesoDatos", function cv($stateParams, AccesoDatos) {
        return AccesoDatos.GestionCurr_CLIENT.registroCv($stateParams.i).then(function (cvResponse) {
          return {
            cv: cvResponse
          };
        });
      }]
    },
    onEnter: ["$state", function onEnter($state) {
      console.log('enter view');

      // $state.go("priv.login")
    }]
    // redirectTo: () => "priv.login"
  });
  $stateProvider.state('priv', {
    url: '/priv',
    template: '<ui-view></ui-view>',
    resolve: {
      // user: ($log: angular.ILogService, $stateParams: ng.ui.IStateParamsService, $state: ng.ui.IStateService, AccesoDatos: AccesoDatos) => {
      //     return AccesoDatos.Login_CLIENT.userDetails().then(login => login, error => {
      //         //
      //         $log.info("sin login")
      //         $state.go("priv.login")
      //     })
      // }
    },
    onEnter: ["$state", function onEnter($state) {
      console.log('enter priv');

      // $state.go("priv.login")
    }],
    redirectTo: function redirectTo() {
      return 'priv.login';
    }
  });
  $stateProvider.state('priv.login0', {
    url: '/login',
    redirectTo: function redirectTo() {
      return 'priv.login';
    }
  });
  $stateProvider.state('priv.login', {
    url: '/loginpriv',
    component: 'loginMain',
    onEnter: function onEnter() {
      console.log('enter login');
    }
  });
  $stateProvider.state('priv.main', {
    url: '/p',
    component: 'privMain',
    resolve: {
      usercfg: ["$log", "$stateParams", "$state", "appConfigService", function usercfg($log, $stateParams, $state, appConfigService) {
        return appConfigService.leerUserConfig().then(function (login) {
          return login;
        }, function (error) {
          //
          $log.info('sin login');
          $state.go('priv.login');
        });
      }]
    },
    onEnter: function onEnter() {
      console.log('enter priv');
    },
    redirectTo: function redirectTo() {
      return 'priv.main.ultimos2';
    }
    // redirectTo: () => "priv.main.curriculums"
  });
  $stateProvider.state('priv.main.flex', {
    // url: "/pf",
    template: '<ui-view class="flex flex-grow flex-col"></ui-view>',
    resolve: {},
    onEnter: function onEnter() {
      console.log('enter priv flex');
    },
    redirectTo: function redirectTo() {
      return 'priv.main.ultimos2';
    }
    // redirectTo: () => "priv.main.curriculums"
  });
  $stateProvider.state('priv.main.ultimos', {
    url: '/ultimos',
    component: 'listaUltimosCurriculums',
    resolve: {
      filtros: function filtros() {
        return false;
      }
    },
    onEnter: function onEnter() {
      console.log('enter listaUltimosCurriculums');
    }
  });
  $stateProvider.state('priv.main.ultimos2', {
    url: '/last',
    component: 'listaUltimosCurriculums',
    resolve: {
      filtros: function filtros() {
        return true;
      }
    },
    onEnter: function onEnter() {
      console.log('enter listaUltimosCurriculums2');
    }
  });
  $stateProvider.state('priv.main.myforms', {
    url: '/mylast',
    component: 'listaMisFormInternos',
    resolve: {
      filtros: function filtros() {
        return true;
      }
    },
    onEnter: function onEnter() {
      console.log('enter listaMisFormInternos');
    }
  });
  $stateProvider.state('priv.main.intro', {
    url: '/intro',
    component: 'panelIntro',
    onEnter: function onEnter() {
      console.log('enter panelIntro');
    }
  });
  $stateProvider.state('priv.main.menu', {
    url: '/menu',
    component: 'panelMenu',
    onEnter: function onEnter() {
      console.log('enter panelMenu');
    }
  });
  $stateProvider.state('priv.main.formular', {
    url: '/form/:idform?',
    component: 'panelFormular',
    resolve: {
      idform: ["$stateParams", function idform($stateParams) {
        return $stateParams.idform;
      }]
    },
    onEnter: function onEnter() {
      console.log('enter panelFormular');
    }
  });
  $stateProvider.state('priv.main.preguntas', {
    url: '/q',
    component: 'panelPreguntas',
    onEnter: function onEnter() {
      console.log('enter panelPreguntas');
    }
  });
  $stateProvider.state('priv.main.estados', {
    url: '/st',
    component: 'panelEstados',
    onEnter: function onEnter() {
      console.log('enter panelEstados');
    }
  });
  $stateProvider.state('priv.main.flex.docreqs', {
    url: '/docreq',
    component: 'panelDocRequirements',
    onEnter: function onEnter() {
      console.log('enter panelDocReqs');
    }
  });
  $stateProvider.state('priv.main.flex.docnotif', {
    url: '/docnotif',
    component: 'panelDocNotifications',
    onEnter: function onEnter() {
      console.log('enter panelDocNotifs');
    }
  });
  $stateProvider.state('priv.main.mainquestions', {
    url: '/mq',
    component: 'panelMainQuestions',
    onEnter: function onEnter() {
      console.log('enter panelMainQuestions');
    }
  });
  $stateProvider.state('priv.main.curriculums', {
    url: '/curr',
    component: 'panelCurriculums',
    onEnter: function onEnter() {
      console.log('enter panelCurriculums');
    }
  });
  $stateProvider.state('priv.main.deletecv', {
    url: '/del',
    component: 'panelDeleteCurriculums',
    resolve: {
      filtros: function filtros() {
        return true;
      }
    },
    onEnter: function onEnter() {
      console.log('enter panelDeleteCurriculums');
    }
  });
  $stateProvider.state('priv.main.historic', {
    url: '/hist',
    component: 'panelBusquedaHistoric',
    resolve: {
      filtros: function filtros() {
        return true;
      }
    },
    onEnter: function onEnter() {
      console.log('enter panelBusquedaHistoric');
    }
  });
  $stateProvider.state('priv.main.historic_rel', {
    url: '/hist_rel',
    component: 'panelCoincidenciasHistoric',
    resolve: {
      filtros: function filtros() {
        return true;
      }
    },
    onEnter: function onEnter() {
      console.log('enter panelCoincidenciasHistoric');
    }
  });
  $stateProvider.state('priv.cvprint', {
    url: '/cvprint/{i}',
    component: 'panelCvPrint',
    onEnter: function onEnter() {
      console.log('enter panelCvPrint');
    },
    resolve: {
      cv: ["$stateParams", "AccesoDatos", function cv($stateParams, AccesoDatos) {
        return AccesoDatos.GestionCurr_CLIENT.registroCv($stateParams.i).then(function (cvResponse) {
          return {
            cv: cvResponse
          };
        });
      }]
    }
  });
  $stateProvider.state('priv.cvpdf', {
    url: '/cvfic/{i}',
    component: 'panelCvPdf',
    onEnter: function onEnter() {
      console.log('enter panelCvPdf');
    },
    resolve: {
      cv: ["$stateParams", "AccesoDatos", function cv($stateParams, AccesoDatos) {
        return AccesoDatos.GestionCurr_CLIENT.registroCv($stateParams.i).then(function (cvResponse) {
          return {
            cv: cvResponse
          };
        });
      }]
    }
  });
  $stateProvider.state('priv.main.cv', {
    url: '/cv?i',
    template: "\n                <sidebar-panel class=\"panel--cv\" visible=\"true\">\n                <if-dev>-- {{ $ctrl.panelcv.$visible }} --</if-dev>\n\n                <panel-cv cv=\"$resolve.cv\"> </panel-cv>\n                </sidebar-panel>",
    // component: "panelCv",
    onEnter: function onEnter() {
      console.log('enter panelCurriculums');
    },
    resolve: {
      cv: ["$stateParams", "AccesoDatos", function cv($stateParams, AccesoDatos) {
        return AccesoDatos.GestionCurr_CLIENT.registroCv($stateParams.i).then(function (cvResponse) {
          return {
            cv: cvResponse
          };
        });
      }]
    }
  });
  $stateProvider.state('cuestionarios', {
    url: '/c',
    template: '<ui-view></ui-view>',
    onEnter: ["$location", function onEnter($location) {
      console.log('enter cuestionarios', $location.search());
      $('body').addClass("bg-caxton container-md cand--public");
    }]
    // redirectTo: () => "priv.main.curriculums"
  });
  $stateProvider.state('cuestionarios.startpubl', {
    url: '/s/{idmenu}?v',
    params: {
      idmenu: {
        squash: true,
        value: null
      }
    },
    component: 'startMenu',
    resolve: {
      idmenu: ["$stateParams", function idmenu($stateParams) {
        return $stateParams.idmenu;
      }],
      version: ["$stateParams", function version($stateParams) {
        return $stateParams.v;
      }],
      accesoPublico: function accesoPublico() {
        return true;
      },
      params: ["$document", function params($document) {
        var search = document.location.search;
        var params = {};
        if (search) {
          new URLSearchParams(window.location.search.substring(1)).forEach(function (val, key) {
            params[key] = val;
          });
        }
        return params;
      }]
    },
    onEnter: function onEnter() {
      console.log('enter startMenu');
    }
  });
  $stateProvider.state('cuestionarios.priv', {
    url: '/priv',
    template: '<ui-view></ui-view>',
    onEnter: ["$location", function onEnter($location) {
      console.log('enter cuestionarios priv', $location.search());
      $('body').addClass("bg-caxton container-md cand--public");
    }],
    resolve: {
      usercfg: ["$log", "$stateParams", "$state", "appConfigService", function usercfg($log, $stateParams, $state, appConfigService) {
        return appConfigService.leerUserConfig().then(function (login) {
          return login;
        }, function (error) {
          //
          $log.info('sin login');
          $state.go('cuestionarios.priv.login');
        });
      }]
    },
    redirectTo: function redirectTo() {
      return 'cuestionarios.priv.login';
    }
    // redirectTo: () => "priv.main.curriculums"
  });
  $stateProvider.state('cuestionarios.priv.login', {
    url: '/login',
    component: 'loginMain',
    resolve: {
      seccionCuestionarios: function seccionCuestionarios() {
        return true;
      }
    },
    onEnter: function onEnter() {
      console.log('enter login cuestionarios');
    }
  });
  $stateProvider.state('cuestionarios.priv.startpriv', {
    url: '/s/{idmenu}?v',
    params: {
      idmenu: {
        squash: true,
        value: null
      }
    },
    component: 'startMenu',
    resolve: {
      idmenu: ["$stateParams", function idmenu($stateParams) {
        return $stateParams.idmenu;
      }],
      version: ["$stateParams", function version($stateParams) {
        return $stateParams.v;
      }],
      accesoPublico: function accesoPublico() {
        return false;
      },
      params: ["$document", function params($document) {
        var search = document.location.search;
        var params = {};
        if (search) {
          new URLSearchParams(window.location.search.substring(1)).forEach(function (val, key) {
            params[key] = val;
          });
        }
        return params;
      }]
    },
    onEnter: function onEnter() {
      console.log('enter startMenu');
    }
  });
  $stateProvider.state('cuestionarios.start2', {
    url: '/s2/{idform}',
    params: {
      idform: {
        squash: true,
        value: null
      }
    },
    component: 'startMenu',
    resolve: {
      idform: ["$stateParams", function idform($stateParams) {
        return $stateParams.idform;
      }]
    },
    onEnter: function onEnter() {
      console.log('enter startMenu');
    }
  });
}]);
$app.run(["$rootScope", "$log", "$transitions", "$location", "CandidatoCfg", function ($rootScope, $log, $transitions, $location, CandidatoCfg) {
  CandidatoCfg.debug = $location.search().dev == 1 || _paramDev_1();
  if (CandidatoCfg.debugforce && !CandidatoCfg.debug) {
    $('body').toggleClass('hide__dev');
  }
  $transitions.onError({}, function (trans) {
    console.log('==================> error', trans, $rootScope);
  });
  $transitions.onSuccess({}, function (trans) {
    console.log('---------------> onSuccess', trans, $rootScope, $transitions);
  });
  $transitions.onEnter({}, function (transition) {
    console.log('Successful enter from ' + transition.from().name + ' to ' + transition.to().name, CandidatoConfig, $location.search().dev);
  });
}]);
function _paramDev_1() {
  try {
    var search = document.location.search;
    var params = new URLSearchParams(search);
    return params.get('dev') == '1';
  } catch (e) {
    return false;
  }
}